// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/SchoolWishListNew/Choose.less
// module id = 1609
// module chunks = 0